import React from 'react'

export default ({items}) => <div className="ms-Grid">
<div className="ms-Grid-row">
    <div className="ms-Grid-col ms-lg12"><h1>Assessments By Rater</h1></div>
</div>
<div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
    <div className="ms-Grid-col ms-lg4">Assessment</div>
    <div className="ms-Grid-col ms-lg4">Employee</div>
    <div className="ms-Grid-col ms-lg4">Rater</div>
</div></div>
{items ? Object.entries(items).map( ([id,assessment]) => 
    <div className="ms-Grid-row">
    <div className="ms-Grid-col ms-lg4">{id}</div>
    <div className="ms-Grid-col ms-lg4">{assessment && assessment.employee? assessment.employee.id : ''}</div>
    {/*<div className="ms-Grid-col ms-lg4">{assessment && assessment.rater ? assessment.rater : ''}</div>*/}
    </div> ): ''}
</div>


// WEBPACK FOOTER //
// ./src/admin/components/Assignment.js